<template>
  <!-- Page title -->
  <div class="page-title py-5 bg-custom-gradient position-relative">
    <div class="container">
      <div class="d-lg-flex d-none flex-lg-row flex-column align-items-lg-center align-items-start justify-content-between">
        <div><h3 class="text-white fw-bold">الملف الشخصي</h3></div>
        <form class="search-form">
          <div class="d-flex flex-column flex-lg-row gap-3">
            <div class="position-relative">
              <div class="form-icon start">
                <i class="fa fa-search text-white"></i>
              </div>
              <input type="text" class="form-control bg-transparent text-white border-2 border-white" placeholder="البحث .." />
            </div>
          </div>
        </form>
      </div>

      <!-- User -->
      <div class="user d-flex align-items-center justify-content-center flex-column position-absolute top-100 start-50 translate-middle">
        <div class="avatar mt-5 position-relative">
          <img src="@/assets/images/user_2x.png" width="152" alt="" />
          <div>
            <label for="avatar" role="button" class="text-white position-absolute bottom-0 start-50 translate-middle">تعديل</label>
            <input type="file" id="avatar" class="form-control d-none" />
          </div>
        </div>
        <div class="d-flex align-items-center mt-4">
          <div class="fs-4 text-primary fw-bold me-2">مدحت عودة</div>
          <button class="btn icon-btn bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center p-3">
            <div class="svg-icon">
              <svg id="icons_Pencil_Line" data-name="icons/Pencil/Line" xmlns="http://www.w3.org/2000/svg" width="19.894" height="19.894" viewBox="0 0 19.894 19.894">
                <path
                  id="Shape"
                  d="M.074,16.241.8,12.98a4,4,0,0,1,1.076-1.961l9.848-9.848a4,4,0,0,1,5.657,0l1.343,1.343a4,4,0,0,1,0,5.657L8.875,18.02A4,4,0,0,1,6.914,19.1l-3.261.725A3,3,0,0,1,.074,16.241Zm2.677-2.827-.725,3.261a1,1,0,0,0,1.193,1.193l3.261-.725a2,2,0,0,0,.949-.508L3.258,12.465A2,2,0,0,0,2.751,13.414ZM4.672,11.05l4.172,4.172,5.586-5.586L10.258,5.465ZM17.308,6.757,15.844,8.222,11.672,4.05l1.465-1.465a2,2,0,0,1,2.828,0l1.343,1.343A2,2,0,0,1,17.308,6.757Z"
                  transform="translate(0 0)"
                  fill="var(--app-primary)"
                />
              </svg>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Content -->
  <div class="container mt-5">
    <div class="clearfix"></div>

    <!-- Setting -->
    <Setting :id="1" :title="'البريد الإلكتروني'" :section_title="'بيانات المستخدم'" :icon="require('@/assets/images/mail.svg')" :status="true" :subtitle="'لتحديد الوقت الخاص بالاجتماع على التقويم لديك'" :visibility="true" :hasToggler="false">
      <div class="w-50">
        <input type="text" class="form-control text-end" placeholder="test@example.com" />
      </div>
      <template v-slot:button><button class="btn btn-primary py-2 px-5 rounded-pill mt-3 fw-bold fw-bold">تحديث</button></template>
    </Setting>
    <!-- Setting -->
    <Setting :id="2" :title="'إعادة تعيين كلمة المرور'" :section_title="'الأمان'" :icon="require('@/assets/images/lock.2.svg')" :status="true" :subtitle="'في حال اردت تغيير كلمة المرور من هنا يمكنك القيام بذلك'" :visibility="true" :hasToggler="false">
      <passwordInput :label="'كلمة المرور القديمة'" :name="'pass-old'" />
      <passwordInput :label="'كلمة المرور الجديدة'" :name="'pass-new'" />
      <passwordInput :label="'تأكيد كلمة المرور'" :name="'pass-reapet'" />
      <template v-slot:button><button class="btn btn-primary py-2 px-5 rounded-pill mt-3 fw-bold fw-bold">تحديث</button></template>
    </Setting>
    <!-- Setting -->
    <Setting :id="3" :title="'التحقق بخطوتين'" :section_title="''" :icon="require('@/assets/images/Icons---General---Shield-protected.svg')" :status="false" :subtitle="'قم بتفعيل التحقق بخطوتين لزيادة امان حسابك '" :visibility="false" :hasToggler="true">nothing to see here!</Setting>
    <!-- Setting -->
    <Setting :id="4" :title="'الجلسات الفعالة'" :section_title="'null'" :icon="require('@/assets/images/computer-mouse.1.svg')" :status="true" :subtitle="'Active accounts'" :visibility="true" :hasToggler="false">
      <div class="session-card card border-2 rounded-5 d-flex flex-row align-items-center p-3 mb-3">
        <img src="@/assets/images/computer.png" class="me-2" width="42" alt="" />
        <div class="d-flex flex-column">
          <h5 class="fs-6 fw-bold">Mac OS X-Chrome</h5>
          <div class="fs-14px d-flex text-secondary inline-list">
            <span>Istanbul</span>
            <span>منذ ساعة</span>
            <span class="text-success fw-bold">هذا الجهاز</span>
          </div>
        </div>
      </div>
      <div class="session-card card border-2 rounded-5 d-flex flex-row align-items-center p-3 mb-3">
        <img src="@/assets/images/computer.png" class="me-2" width="42" alt="" />
        <div class="d-flex flex-column">
          <h5 class="fs-6 fw-bold">Mac OS X-Chrome</h5>
          <div class="fs-14px d-flex text-secondary inline-list">
            <span>Istanbul</span>
            <span>منذ ساعة</span>
            <span class="text-success fw-bold">هذا الجهاز</span>
          </div>
        </div>
      </div>
      <button class="btn btn-outline-primary rounded-pill py-2 px-3 d-flex gap-2 fw-bold">
        <div class="svg-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18.086" height="20" viewBox="0 0 18.086 20">
            <g id="logout" transform="translate(-3 -2)">
              <path id="Path_87" data-name="Path 87" d="M17.707,7.793a1,1,0,0,0-1.414,1.414L18.086,11H9a1,1,0,0,0,0,2h9.086l-1.793,1.793a1,1,0,0,0,1.414,1.414L20.5,13.414a2,2,0,0,0,0-2.828Z" fill="currentColor" />
              <path id="Path_88" data-name="Path 88" d="M3,5A3,3,0,0,1,6,2h6a3,3,0,0,1,3,3V6a1,1,0,0,1-2,0V5a1,1,0,0,0-1-1H6A1,1,0,0,0,5,5V19a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V18a1,1,0,0,1,2,0v1a3,3,0,0,1-3,3H6a3,3,0,0,1-3-3Z" fill="currentColor" />
            </g>
          </svg>
        </div>
        تسجيل الخروج من كافة الأجهزة
      </button>
    </Setting>
    <!-- Setting -->
    <Setting :id="5" :title="'الفريق'" :section_title="'الفريق / الصلاحيات'" :icon="require('@/assets/images/teams.svg')" :status="true" :subtitle="'يمكنك استخدام الفريق اذا احتجت لمستخدمين اخرين لإدارة مواعيدك'" :visibility="true" :hasToggler="true">
      <TeamCard :team_name="'مساق'" :team_users="4" :team_meetings="21" :team_avatar="require('@/assets/images/msaaq.svg')" />
      <TeamCard :team_name="'بلورة'" :team_users="3" :team_meetings="24" :team_avatar="require('@/assets/images/blora.jpg')" />
      <button data-bs-toggle="modal" data-bs-target="#addteamModal" class="btn btn-outline-primary rounded-pill py-2 px-3 d-flex gap-2 fw-bold">
        <div class="svg-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
            <g id="plus" transform="translate(-4 -4)">
              <path id="Line_1" data-name="Line 1" d="M-.086,13A.9.9,0,0,1-1,12.125V-.125A.9.9,0,0,1-.086-1a.9.9,0,0,1,.914.875v12.25A.9.9,0,0,1-.086,13Z" transform="translate(11.086 5)" fill="currentColor" />
              <path id="Line_2" data-name="Line 2" d="M12.125.828H-.125A.9.9,0,0,1-1-.086.9.9,0,0,1-.125-1h12.25A.9.9,0,0,1,13-.086.9.9,0,0,1,12.125.828Z" transform="translate(5 11.086)" fill="currentColor" />
            </g>
          </svg>
        </div>
        إنشاء فريق جديد
      </button>
    </Setting>
    <!-- Setting -->
    <Setting
      :id="6"
      :title="'حذف الحساب'"
      :section_title="'المنطقة الخطرة'"
      :icon="require('@/assets/images/trash2.svg')"
      :status="true"
      :subtitle="`نحزن كثيراً في حال قيامك بهذا الأمر إن كان لديك اي استفسار او مشكلة يمكنك  <a href='#' class='text-primary fw-bold'>تواصل معنا</a>`"
      :visibility="true"
      :hasToggler="false"
    >
      <button class="btn text-decoration-underline gap-2 text-danger d-flex align-items-center p-0 fw-bold">
        <div class="svg-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20.225" height="20.225" viewBox="0 0 20.225 20.225">
            <g id="Group_1295" data-name="Group 1295" transform="translate(-2 -2)">
              <path id="Path_67" data-name="Path 67" d="M10.011,10a1.011,1.011,0,0,1,1.011,1.011v5.056a1.011,1.011,0,1,1-2.022,0V11.011A1.011,1.011,0,0,1,10.011,10Z" transform="translate(0.079 0.09)" fill="currentColor" fill-rule="evenodd" />
              <path id="Path_68" data-name="Path 68" d="M14.011,10a1.011,1.011,0,0,1,1.011,1.011v5.056a1.011,1.011,0,1,1-2.022,0V11.011A1.011,1.011,0,0,1,14.011,10Z" transform="translate(0.124 0.09)" fill="currentColor" fill-rule="evenodd" />
              <path
                id="Path_69"
                data-name="Path 69"
                d="M10.09,2A3.034,3.034,0,0,0,7.056,5.034H3.011a1.011,1.011,0,0,0,0,2.022H4.022V19.191a3.034,3.034,0,0,0,3.034,3.034H17.168A3.034,3.034,0,0,0,20.2,19.191V7.056h1.011a1.011,1.011,0,1,0,0-2.022H17.168A3.034,3.034,0,0,0,14.135,2Zm5.056,3.034a1.011,1.011,0,0,0-1.011-1.011H10.09A1.011,1.011,0,0,0,9.079,5.034ZM7.056,7.056H6.045V19.191A1.011,1.011,0,0,0,7.056,20.2H17.168a1.011,1.011,0,0,0,1.011-1.011V7.056H7.056Z"
                fill="currentColor"
                fill-rule="evenodd"
              />
            </g>
          </svg>
        </div>
        حذف الحساب بالكامل
      </button>
    </Setting>
  </div>
  <!-- Create Team Modal -->
  <Modal :form_img="true" :modal_img="require('@/assets/images/msaaq.svg')" :close_btn_color="'white'" :modal_title="'إنشاء فريق'" :name="'addteam'">
    <form>
      <div class="mb-3">
        <label>اسم الفريق</label>
        <input type="text" class="form-control text-secondary" placeholder="Msaaq" />
      </div>
      <div class="mb-3">
        <label>التوقيت الزمني</label>
      <div class="multiselect-custom-container">
                  <div class="multiselect-custom-container">
                    <Multiselect class="form-control mutliselect-custom text-secondary" v-model="value" :placeholder="'إختر'" :searchable="true" :options="options" />
                  </div>
      </div>
      </div>
      <div class="d-grid">
        <button class="btn btn-primary rounded-pill py-2">حفظ</button>
      </div>
    </form>
  </Modal>

  <!-- Invite User -->
  <Modal :form_img="false" :modal_img="require('@/assets/images/msaaq.svg')" :close_btn_color="'white'" :modal_title="'دعوة مستخدم'" :name="'invite'">
    <form>
      <div class="mb-3">
        <label>البريد</label>
        <input type="email" class="form-control text-secondary" placeholder="Msaaq@example.com" />
      </div>
      <div class="border border-1 my-4"></div>
      <div>
        <h6 class="fs-6 fw-bold">نوع الحساب</h6>
        <div class="radio-group radio-with-text-2 btn-group d-flex flex-column gap-2" role="group" aria-label="Basic radio toggle button group">
          <div class="position-relative">
            <input type="radio" class="form-check-input bg-transparent" name="btnradio" id="btnradio1" autocomplete="off" />
            <label class="btn btn-outline-primary text-start w-100 d-flex align-items-center gap-4" for="btnradio1">
              <div></div>
              <div class="d-flex flex-column">
                <h5 class="text-black fw-bold fs-6">مسؤول</h5>
                <span class="fs-14px text-secondary">بإمكانه التعديل على كل شيء</span>
              </div>
            </label>
          </div>
          <div class="position-relative">
            <input type="radio" class="form-check-input bg-transparent" name="btnradio" id="btnradio2" autocomplete="off" />
            <label class="btn btn-outline-primary text-start w-100 d-flex align-items-center gap-4" for="btnradio2">
              <div></div>
              <div class="d-flex flex-column">
                <h5 class="text-black fw-bold fs-6">المحرر</h5>
                <span class="fs-14px text-secondary">بإمكانه التعديل على المواعيد فقط</span>
              </div>
            </label>
          </div>
        </div>
      </div>
      <div class="d-grid mt-4">
        <button class="btn btn-primary rounded-pill py-2">حفظ</button>
      </div>
    </form>
  </Modal>
</template>

<script>
import Setting from '../components/Setting.vue'
import passwordInput from '../components/passwordInput.vue'
import TeamCard from '../components/TeamCard.vue'
import Modal from '../components/Modal.vue'
import Multiselect from '@vueform/multiselect'
import { ref } from '@vue/reactivity'
export default {
  name: 'Profile',
  components: {Setting, passwordInput, TeamCard, Modal, Multiselect},

  setup() {
    const value = ref(null)
    const options = ref(['GMT', 'UTC'])

    return {options, value}
  },
}
</script>

<style>
</style>